function VideoCards() {
  return (
    <div style={styles.container}>
      {/* Cricket */}
      <div style={styles.card}>
        <video autoPlay loop muted playsInline style={styles.video}>
          <source src="/videos/cricket.mp4" type="video/mp4" />
        </video>

        <div style={styles.label}>🏏 Cricket</div>
      </div>

      {/* Badminton */}
      <div style={styles.card}>
        <video autoPlay loop muted playsInline style={styles.video}>
          <source src="/videos/badminton.mp4" type="video/mp4" />
        </video>

        <div style={styles.label}>🏸 Badminton</div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    gap: "30px",
    marginTop: "20px",
    padding: "20px",
    flexWrap: "wrap",
  },

  card: {
    width: "450px",
    height: "280px",
    borderRadius: "20px",
    overflow: "hidden",
    position: "relative",
    boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
    cursor: "pointer",
  },

  video: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  label: {
    position: "absolute",
    bottom: "10px",
    left: "10px",
    background: "rgba(255,255,255,0.9)",
    padding: "6px 12px",
    borderRadius: "10px",
    fontWeight: "bold",
  },
};

export default VideoCards;